import { UserAdapters } from '../adapters';
import { UsersApi } from '../clients';

/**
 * How many locations each identity can access, keyed by identity id.
 *
 * @param {string[]} identityIds - See `clients/GetIdentityLocationCounts`.
 * @returns {Promise<Object<string, number>>}
 */
export const getIdentityLocationCounts = async (identityIds) => {
  const response = await UsersApi.getIdentityLocationCounts(identityIds);

  return UserAdapters.toLocationCountsById(response);
};
